import React from "react";
import PropTypes from "prop-types";
import {
  Grid,
  Box,
  Button,
  Typography,
  darken,
  TextField,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { validateEmail } from "../../../logic/Validator";
import UploadFile from "@mui/icons-material/UploadFile";
import InputText from "../../Fields/InputText";
import TextBox from "../../Fields/TextBox";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import Signatory from "./Signatory";

const mailformat = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
const socialSecurityNumberCountries = ["se", "dk", "no", "fi"];
const formColor = { hcs: "#273A60", arjo: "#0F5376" };

export default class CustomerInformationBusiness extends React.Component {
  static propTypes = {
    changeHandler: PropTypes.func,
    checkHandler: PropTypes.func,
    customerInformation: PropTypes.object,
    formInformation: PropTypes.object,
    labels: PropTypes.object,
    addSignatory: PropTypes.func,
    removeSignatory: PropTypes.func,
    addExtraFiles: PropTypes.func,
    removeExtraFiles: PropTypes.func,
    extraFiles: PropTypes.array,
    className: PropTypes.string,
    formType: PropTypes.string,
    params: PropTypes.object,
  };

  state = {
    customerName: false,
    companyNumber: false,
    customerGeneralContact: false,
    customerEmail: false,
    customerInvoiceEmail: false,
    signatory: false,
    address: false,
    zipCode: false,
    city: false,
  };

  componentDidMount() {
    this.setState(this.checkFieldsFinsished());
    if (
      socialSecurityNumberCountries.includes(
        this.props.params.lang.toLowerCase(),
      )
    ) {
      this.setState({ dateOfBirthCustomerSignatory: true });
    } else {
      this.setState({ socialSecurityNumberCustomerSignatory: true });
    }
  }

  handleChecked = (event) => {
    this.props.checkHandler(event);
  };

  generateSignatory = (id) => {
    const formType = this.props.formType;
    const orderChecked = this.props.formInformation.orderChecked;
    const hasInvoiceEmail =
      (formType === "upcare" || formType === "flexpro") && orderChecked;
    return (
      <Signatory
        signatory={this.props.customerInformation.signatories[id]}
        formInformation={this.props.formInformation}
        labels={this.props.labels}
        id={id}
        changeHandler={this.handleSignatoryChange}
        key={id}
        validName={this.state.nameSignatory}
        validEmail={this.state.emailSignatory}
        validPhone={this.state.phoneSignatory}
        className={"invalid"}
        formType={this.props.formType}
        onBoarding={false}
        params={this.props.params}
        number={id.charAt(id.length - 1)}
        invoiceEmail={
          hasInvoiceEmail
            ? this.props.customerInformation.customerInvoiceEmail
            : undefined
        }
      />
    );
  };

  handleChange = (value, id) => {
    let newState = this.checkFieldsFinsished();
    newState[id] = id.includes("Email") ? validateEmail(value) : value !== "";
    let data = {};
    data["businessFinished"] = Object.values(newState).every((finished) => {
      return finished;
    });
    data[id] = value;
    this.props.changeHandler(data);
    this.setState(newState);
  };

  checkFieldsFinsished = () => {
    const formType = this.props.formType;
    const orderChecked = this.props.formInformation.orderChecked;
    let newState = this.state;
    for (let key in newState) {
      if (
        (this.props.customerInformation[key] !== undefined &&
          this.props.customerInformation[key] !== "" &&
          this.props.customerInformation[key] !== null) ||
        ((key === "address" || key === "city" || key === "zipCode") &&
          !(
            this.props.params.lang === "at" || this.props.params.lang === "de"
          )) ||
        (key === "customerInvoiceEmail" &&
          ((formType !== "upcare" && formType !== "flexpro") ||
            !orderChecked)) ||
        (key === "customerGeneralContact" &&
          (formType !== "upcare" || !orderChecked))
      ) {
        newState[key] = true;
      }
    }
    let signatories = this.props.customerInformation.signatories;
    newState["signatory"] = this.signatoryFinished(signatories);
    newState["customerEmail"] = validateEmail(
      this.props.customerInformation.customerEmail,
    );
    newState["customerInvoiceEmail"] =
      (formType === "upcare" || formType === "flexpro") && orderChecked
        ? validateEmail(this.props.customerInformation.customerInvoiceEmail)
        : true;
    return newState;
  };

  signatoryFinished = (signatories) => {
    let signatory = true;
    for (const key1 in signatories) {
      for (const key2 in signatories[key1]) {
        if (
          signatories[key1][key2] === undefined ||
          signatories[key1][key2] === "" ||
          signatories[key1][key2] === null ||
          (key2 === "emailSignatory" && !validateEmail(signatories[key1][key2]))
        ) {
          if (
            (key2 === "dateOfBirthCustomerSignatory" &&
              socialSecurityNumberCountries.includes(
                this.props.params.lang.toLowerCase(),
              )) ||
            (key2 === "socialSecurityNumberCustomerSignatory" &&
              !socialSecurityNumberCountries.includes(
                this.props.params.lang.toLowerCase(),
              )) ||
            ((key2 === "idNumberSignatory" ||
              key2 === "idTypeSignatory" ||
              key2 === "pepSignatory") &&
              this.props.params.lang.toLowerCase() !== "at")
          ) {
            continue;
          }
          signatory = false;
        }
      }
    }
    return signatory;
  };

  addRemoveSignatory = (id) => {
    if (id === "remove") {
      this.props.removeSignatory(false);
    }
    if (id === "add") {
      this.props.addSignatory(false);
    }
    let data = {};
    let newState = this.checkFieldsFinsished();
    let signatories = this.props.customerInformation.signatories;
    newState["signatory"] = this.signatoryFinished(signatories);
    data["businessFinished"] = Object.values(newState).every((finished) => {
      return finished;
    });

    this.props.changeHandler(data);
    this.setState(newState);
  };

  handleSignatoryChange = (value, id, signatoryId) => {
    let data = {};
    let newState = this.checkFieldsFinsished();

    let signatories = this.props.customerInformation.signatories;
    let signatory = signatories[signatoryId];
    signatory[id] = value;
    signatories[signatoryId] = signatory;
    data["signatories"] = signatories;

    newState["signatory"] = this.signatoryFinished(signatories);
    data["businessFinished"] = Object.values(newState).every((finished) => {
      return finished;
    });

    this.props.changeHandler(data);
    this.setState(newState);
  };
  handleAddfile = (event) => {
    const allowedTypes = ["image/jpeg", "application/pdf", "image/png"];
    const files = [];
    for (let i = 0; i < event.target.files.length; i++) {
      const file = event.target.files[i];
      if (!allowedTypes.includes(file.type)) {
        alert(this.props.labels.wrong_filetype);
        continue;
      }
      if (!this.props.extraFiles.some((f) => f.name === file.name)) {
        files.push(file);
      } else {
        alert(this.props.labels.duplicate_filename);
      }
    }
    if (files.length > 0) this.props.addExtraFiles(files);
    event.target.value = null;
  };

  handleRemoveFile = (file) => {
    this.props.removeExtraFiles(file);
  };

  render() {
    const lang = this.props.params.lang.toLowerCase();
    const formType = this.props.formType;
    const orderChecked = this.props.formInformation.orderChecked;
    const hasInvoiceEmail =
      (formType === "upcare" || formType === "flexpro") && orderChecked;
    const hasGeneralContactPerson = formType === "upcare" && orderChecked;
    const isInvoiceEmailMatchingSignatory = Object.values(
      this.props.customerInformation.signatories,
    ).some(
      (signatory) =>
        signatory.emailSignatory ===
        this.props.customerInformation.customerInvoiceEmail,
    );

    return (
      <div>
        <Grid container spacing={2} className="customer_info">
          {!hasInvoiceEmail && (
            <Grid item xs={4}>
              <InputText
                id="customerName"
                label={
                  formType !== "standard"
                    ? this.props.labels.company
                    : this.props.labels.company_name_text
                }
                changeHandler={this.handleChange}
                defaultValue={this.props.customerInformation.customerName}
                tooltip={this.props.labels.tooltip_company_name}
                required={true}
                sx={{ width: "100%" }}
                className={
                  this.props.formInformation.showInvalid &&
                  !this.state.customerName
                    ? "invalid"
                    : ""
                }
              />
            </Grid>
          )}
          {(this.props.params.lang.toLowerCase() === "de" ||
            this.props.params.lang.toLowerCase() === "at") && (
            <>
              <Grid item xs={4}>
                <InputText
                  id="address"
                  label={this.props.labels.label_address}
                  changeHandler={this.handleChange}
                  defaultValue={this.props.customerInformation.address}
                  tooltip={this.props.labels.tooltip_customer_address}
                  required={true}
                  sx={{ width: "100%" }}
                  className={
                    this.props.formInformation.showInvalid &&
                    !this.state.address
                      ? "invalid"
                      : ""
                  }
                />
              </Grid>
              <Grid item xs={4}>
                <InputText
                  id="city"
                  label={this.props.labels.label_city}
                  changeHandler={this.handleChange}
                  defaultValue={this.props.customerInformation.city}
                  required={true}
                  sx={{ width: "100%" }}
                  className={
                    this.props.formInformation.showInvalid && !this.state.city
                      ? "invalid"
                      : ""
                  }
                />
              </Grid>
              <Grid item xs={4}>
                <InputText
                  id="zipCode"
                  label={this.props.labels.label_zip_code}
                  changeHandler={this.handleChange}
                  defaultValue={this.props.customerInformation.zipCode}
                  required={true}
                  sx={{ width: "100%" }}
                  className={
                    this.props.formInformation.showInvalid &&
                    !this.state.zipCode
                      ? "invalid"
                      : ""
                  }
                />
              </Grid>
            </>
          )}
          <Grid
            item
            xs={hasGeneralContactPerson ? 6 : hasInvoiceEmail ? 3.6 : 4}
          >
            <InputText
              id="companyNumber"
              label={this.props.labels.company_number}
              changeHandler={this.handleChange}
              defaultValue={this.props.customerInformation.companyNumber}
              tooltip={this.props.labels.tooltip_company_number}
              required={true}
              sx={{ width: "100%" }}
              className={
                this.props.formInformation.showInvalid &&
                !this.state.companyNumber
                  ? "invalid"
                  : ""
              }
            />
          </Grid>

          {hasGeneralContactPerson && (
            <Grid item xs={6}>
              <InputText
                id="customerGeneralContact"
                label={this.props.labels.general_contact_person}
                changeHandler={this.handleChange}
                defaultValue={
                  this.props.customerInformation.customerGeneralContact
                }
                required={true}
                sx={{ width: "100%" }}
                className={
                  this.props.formInformation.showInvalid &&
                  !this.state.customerGeneralContact
                    ? "invalid"
                    : ""
                }
              />
            </Grid>
          )}

          <Grid
            item
            xs={hasGeneralContactPerson ? 6 : hasInvoiceEmail ? 4.2 : 4}
          >
            <InputText
              id="customerEmail"
              label={
                hasInvoiceEmail
                  ? this.props.labels.general_contact_email
                  : this.props.labels.label_invoice_email
              }
              changeHandler={this.handleChange}
              defaultValue={this.props.customerInformation.customerEmail}
              tooltip={
                !hasInvoiceEmail
                  ? this.props.labels.tooltip_invoice_email
                  : undefined
              }
              required={true}
              sx={{ width: "100%" }}
              className={
                this.props.formInformation.showInvalid &&
                (!this.state.customerEmail ||
                  this.props.customerInformation.customerEmail ===
                    this.props.customerInformation.dealerEmail ||
                  (hasInvoiceEmail &&
                    this.props.customerInformation.customerEmail ===
                      this.props.customerInformation.customerInvoiceEmail))
                  ? "invalid"
                  : ""
              }
            />
          </Grid>

          {hasInvoiceEmail && (
            <Grid item xs={hasGeneralContactPerson ? 6 : 4.2}>
              <InputText
                id="customerInvoiceEmail"
                label={this.props.labels.customer_invoice_email}
                changeHandler={this.handleChange}
                defaultValue={
                  this.props.customerInformation.customerInvoiceEmail
                }
                required={true}
                sx={{ width: "100%" }}
                className={
                  this.props.formInformation.showInvalid &&
                  (!this.state.customerInvoiceEmail ||
                    this.props.customerInformation.customerInvoiceEmail ===
                      this.props.customerInformation.customerEmail ||
                    isInvoiceEmailMatchingSignatory)
                    ? "invalid"
                    : ""
                }
              />
            </Grid>
          )}
        </Grid>
        <br></br>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              value={this.props.labels.limited_comapny}
              sx={{ "& input": { fontWeight: "bold" } }}
              InputProps={{
                readOnly: true,
              }}
              variant="standard"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sx={{ display: "flex", gap: 1 }}>
            <FormControlLabel
              label={this.props.labels.positive_answer}
              control={
                <Checkbox
                  id="limited_company"
                  checked={this.props.formInformation.limitedCompanyChecked}
                  onChange={this.handleChecked}
                  sx={{ opacity: 0, width: 0, height: 0, p: 0, m: 0 }}
                />
              }
              sx={{
                width: "150px",
                minHeight: "50px",
                boxSizing: "border-box",
                m: 0,
                px: 2,
                py: 1,
                border: `1px solid ${this.props.formInformation.limitedCompanyChecked ? this.props.color : "#000000"}`,
                borderRadius: "4px",
                backgroundColor: this.props.formInformation
                  .limitedCompanyChecked
                  ? this.props.color
                  : "transparent",
                color: this.props.formInformation.limitedCompanyChecked
                  ? "#ffffff"
                  : "#000000",
                cursor: "pointer",
                justifyContent: "center",
                transition: "background-color 0.2s ease, color 0.2s ease",
                "& .MuiFormControlLabel-label": {
                  color: "inherit",
                  width: "100%",
                  textAlign: "center",
                  fontWeight: "bold",
                },
              }}
            />
            <FormControlLabel
              label={this.props.labels.negative_answer}
              control={
                <Checkbox
                  id="limited_company_no"
                  checked={this.props.formInformation.limitedCompanyNotChecked}
                  onChange={this.handleChecked}
                  sx={{ opacity: 0, width: 0, height: 0, p: 0, m: 0 }}
                />
              }
              sx={{
                width: "150px",
                minHeight: "50px",
                boxSizing: "border-box",
                m: 0,
                px: 2,
                py: 1,
                border: `1px solid ${this.props.formInformation.limitedCompanyNotChecked ? this.props.color : "#000000"}`,
                borderRadius: "4px",
                backgroundColor: this.props.formInformation
                  .limitedCompanyNotChecked
                  ? this.props.color
                  : "transparent",
                color: this.props.formInformation.limitedCompanyNotChecked
                  ? "#ffffff"
                  : "#000000",
                cursor: "pointer",
                justifyContent: "center",
                transition: "background-color 0.2s ease, color 0.2s ease",
                "& .MuiFormControlLabel-label": {
                  color: "inherit",
                  width: "100%",
                  textAlign: "center",
                  fontWeight: "bold",
                },
              }}
            />
          </Grid>
        </Grid>
        {this.props.formInformation.limitedCompanyNotChecked && (
          <Grid
            container
            spacing={2}
            mt={2}
            className="customer_info paddingBottom"
          >
            <Grid item xs={12}>
              <Box textAlign="left">
                {this.props.extraFiles.length === 0 &&
                  this.props.customerInformation.companyTypeKey !==
                    "municipality" && (
                    <Typography
                      variant="caption"
                      display="block"
                      gutterBottom
                      style={{ fontSize: "1.3rem", color: "red" }}
                    >
                      <strong>{this.props.labels.companytype_more_info}</strong>
                    </Typography>
                  )}
                <Button
                  variant="contained"
                  component="label"
                  sx={{
                    backgroundColor: this.props.color,
                    "&:hover": {
                      backgroundColor: darken(this.props.color, 0.2),
                    },
                    marginBottom: 0.5,
                  }}
                  startIcon={<UploadFile />}
                >
                  {this.props.labels.upload_extra_files}
                  <input
                    type="file"
                    accept="image/jpeg, application/pdf, image/png"
                    multiple
                    hidden
                    onChange={this.handleAddfile}
                  />
                </Button>
              </Box>
              {this.props.extraFiles.length > 0 && (
                <div>
                  <p>{this.props.labels.uploaded_files} </p>
                  {this.props.extraFiles.map((file) => (
                    <Button
                      variant="text"
                      className="file"
                      key={file.name}
                      onClick={() => this.handleRemoveFile(file)}
                    >
                      {file.name}
                    </Button>
                  ))}
                </div>
              )}
            </Grid>
          </Grid>
        )}
        <br></br>
        {(formType === "upcare" || formType === "flexpro") &&
          (lang === "se" || lang === "fr" || lang === "dk") && (
            <Grid item xs={12}>
              <FormControlLabel
                className="peppol_checked"
                control={
                  <Checkbox
                    id="peppol_checked"
                    checked={this.props.formInformation.peppol}
                    onChange={this.handleChecked}
                  />
                }
                label={this.props.labels.peppol}
                sx={{ width: "100%" }}
              />
            </Grid>
          )}
        <div>
          {Object.keys(this.props.customerInformation.signatories).map((id) => {
            return this.generateSignatory(id);
          })}
        </div>
        <div className="row padding-Top">
          <div className="buttonPadding">
            <Button
              sx={{
                backgroundColor: this.props.color,
                "&:hover": {
                  backgroundColor: darken(this.props.color, 0.2), // Darken by 20%
                },
              }}
              onClick={() => {
                this.addRemoveSignatory("add");
              }}
              variant="contained"
              startIcon={<AddCircleOutlineIcon />}
            >
              {this.props.labels.label_add_signatory}
            </Button>
          </div>
          {Object.keys(this.props.customerInformation.signatories).length >
            1 && (
            <div className="buttonPadding">
              <Button
                onClick={() => {
                  this.addRemoveSignatory("remove");
                }}
                variant="contained"
                color="error"
                startIcon={<RemoveCircleOutlineIcon />}
              >
                {this.props.labels.label_remove_signatory}
              </Button>
            </div>
          )}
        </div>
      </div>
    );
  }
}
